import React, {useRef} from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import "assets/scss/material-kit-react.scss?v=1.9.0";
import LandingPage from "./views/LandingPage.js";
import LoginPage from "./views/LoginPage.js";
import PrivacyPolicy from "./views/PrivacyPolicy.js";
import AboutUs from "./views/AboutUs";
import AuthLoading from './views/AuthLoading';
import { Provider } from "react-redux";
import ProtectedRoute from './views/ProtectedRoute';
import MyProfile from './views/MyProfile';
import BookingHistory from './views/BookingHistory';
import Dashboard from './views/Dashboard';
import CarTypes from './views/CarTypes';
import AddBookings from './views/AddBookings';
import Promos from './views/Promos';
import Riders from './views/Riders';
import Drivers from './views/Drivers';
import FleetAdmins from './views/FleetAdmins';
import Notifications from './views/Notifications';
import DriverEarning from './views/DriverEarning';
import Earningreports from './views/Earningreports';
import Settings from './views/Settings';
import LanguageSetting from "./views/LanguageSetting";
import AppInformation from "./views/AppInformation";
import Withdraws from './views/Withdraws';
import CancellationReasons from './views/CancellationReasons';
import RegisterPage from './views/RegisterPage';
import AddMoney from "./views/AddMoney";
import { FirebaseProvider, store } from "common";
import { FirebaseConfig } from './config/FirebaseConfig';
import { GoogleMapApiConfig } from './config/GoogleMapApiConfig';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import CreateAdmin from './views/CreateAdmin';
import ReportDetails from "./views/ReportDetails";
import RideHistory from "./views/RideHistory";
import DriveHistory from "./views/DriveHistory";
import EditPromo from "./views/EditPromo";
import EditFleetAdmin from "./views/EditFleetAdmin";
import BookingHistoryDetails from "./views/BookingHistoryDetails";
import AddCar from './views/AddCar';
import AddPromo from './views/AddPromo';
import AddDriver from './views/AddDriver';
import AddRider from './views/AddRider';
import EditRider from './views/EditRider';
import AddFleetAdmins from './views/AddFleetAdmins';
import DriverDocument from "./views/DriverDocument";
import EditDriver from './views/EditDriver';
import EditCarType from './views/EditCarType';
import EditAdmin from './views/EditAdmin';
import AddAdmin from './views/AddAdmin';
import EarningReportsDetails from './views/EarningReportsDetails';
import Subscription from './views/Subscription';
import AddSubscription from './views/AddSubscription';
import EditSubscription from './views/EditSubscription';
import TermsAndCondition from './views/TermsAndCondition';
import SubscriptionReport from './views/SubscriptionReport';
import CorporateAdmin from './views/CorporateAdmin';
import AddCorporateAdmin from './views/AddCorporateAdmin';
import EditCorporateAdmin from './views/EditCorporateAdmin';
import WithdrawsReports from './views/WithdrawsReports';
import WithdrawList from './views/WithdraList';
import CorporateEarning from './views/CorporateEarning';
import CorporateHistory from './views/CorporateHistory';
import FleetAdminBookingHistory from './views/FleetAdminHistory';
import FleetEarning from './views/FleetEarning';
import AdminReport from './views/AdminReport';
import AddMultiDoc from './views/AddMultiDoc';

i18n
.use(initReactI18next) 
.init({
    resources: {},
    fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
        escapeValue: false
    }
});

function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

var hist = createBrowserHistory();

function App() {
  const loaded = useRef(false);
  if (typeof window !== 'undefined' && !loaded.current && !window.google) {
    if (!document.querySelector('#google-maps')) {
      loadScript(
        'https://maps.googleapis.com/maps/api/js?key=' + GoogleMapApiConfig + '&libraries=geometry,drawing,places',
        document.querySelector('head'),
        'google-maps',
      );
    }
    loaded.current = true;
  }

  return (
    <Provider store={store}>
      <FirebaseProvider config={FirebaseConfig}>
        <AuthLoading>
          <Router history={hist}>
            <Switch>
              <ProtectedRoute exact component={BookingHistory} path="/bookings" permit={"rider,admin,driver,fleetadmin,corporateAdmin"} />
              <ProtectedRoute exact component={MyProfile} path="/profile" permit={"rider,admin,driver,fleetadmin,corporateAdmin"} />
              <ProtectedRoute exact component={Dashboard} path="/dashboard" permit={"admin"} />
              <ProtectedRoute exact component={CarTypes} path="/cartypes" permit={"admin"} />
              <ProtectedRoute exact component={CancellationReasons} path="/cancelreasons" permit={"admin"} />
              <ProtectedRoute exact component={AddBookings} path="/addbookings" permit={"admin,fleetadmin,corporateAdmin"} />
              <ProtectedRoute exact component={Promos} path="/promos" permit={"admin"} />
              <ProtectedRoute exact component={Riders} path="/riders" permit={"admin"} />
              <ProtectedRoute exact component={Drivers} path="/drivers" permit={"admin,fleetadmin"} />
              <ProtectedRoute exact component={CreateAdmin} path="/alladmin" permit={"admin"} />
              <ProtectedRoute exact component={FleetAdmins} path="/fleetadmins" permit={"admin"} />
              <ProtectedRoute exact component={FleetAdminBookingHistory} path="/fleetAdminBookingHistory" permit={"admin"}/>
              <ProtectedRoute exact component={CorporateAdmin} path="/corporateAdmin" permit={"admin"} />
              <ProtectedRoute exact component={DriverEarning} path="/driverearning" permit={"admin,fleetadmin"} />
              <ProtectedRoute exact component={Notifications} path="/notifications" permit={"admin"} />
              <ProtectedRoute exact component={Earningreports} path="/earningreports" permit={"admin"} />
              <ProtectedRoute exact component={AddMoney} path="/addtowallet" permit={"admin"} />
              <ProtectedRoute exact component={Withdraws} path="/withdraws" permit={"admin"} />
              <ProtectedRoute exact component={Settings} path="/settings" permit={"admin"} />
              <ProtectedRoute exact component={AppInformation} path="/appinfo" permit={"admin"} />
              <ProtectedRoute exact component={LanguageSetting} path="/languagesetting" permit={"admin"} />  
              <ProtectedRoute exact component={RideHistory} path="/ridehistory" permit={"admin,rider,corporateAdmin"} /> 
              <ProtectedRoute exact component={DriveHistory} path="/drivehistory" permit={"admin,driver,fleetadmin"} />  
              <ProtectedRoute exact component={ReportDetails} path="/reportdetails" permit={"admin"} />     
              <ProtectedRoute exact component={EditPromo} path="/editpromo" permit={"admin"} />  
              <ProtectedRoute exact component={EditFleetAdmin} path="/editFleetAdmin" permit={"admin"} />  
              <ProtectedRoute exact component={BookingHistoryDetails} path="/bookinghistorydetails" permit={"rider,admin,driver,fleetadmin,corporateAdmin"} />     
              <ProtectedRoute exact component={AddCar} path="/addcar" permit={"admin"} />
              <ProtectedRoute exact component={AddRider} path="/addrider" permit={"admin,corporateAdmin"} />
              <ProtectedRoute exact component={EditRider} path="/editrider" permit={"admin,corporateAdmin"} />
              <ProtectedRoute exact component={AddAdmin} path="/addadmin" permit={"admin"} />  
              <ProtectedRoute exact component={AddPromo} path="/addpromo" permit={"admin"} />
              <ProtectedRoute exact component={AddFleetAdmins} path="/addfleetadmins" permit={"admin"} />
              <ProtectedRoute exact component={AddCorporateAdmin} path="/addcorporateAdmin" permit={"admin"} />
              <ProtectedRoute exact component={AddDriver} path="/adddriver" permit={"admin,fleetadmin"} />
              <ProtectedRoute exact component={EditDriver} path="/editdriver" permit={"admin"} />
              <ProtectedRoute exact component={EditCarType} path="/editcartype" permit={"admin"} />
              <ProtectedRoute exact component={EditAdmin} path="/editadmin" permit={"admin"} />
              <ProtectedRoute exact component={EditCorporateAdmin} path="/editCorporateAdmin" permit={"admin"} />
              <ProtectedRoute exact component={DriverDocument} path="/driverdocument" permit={"admin,fleetadmin"} />
              <ProtectedRoute exact component={AddMultiDoc} path="/addMultiDoc" permit={"admin,fleetadmin"} />
              <ProtectedRoute exact component={EarningReportsDetails} path="/earningreportsdetails" permit={"admin,corporateAdmin"} />
              <ProtectedRoute exact component={Subscription} path="/subscription" permit={"admin"} />
              <ProtectedRoute exact component={AddSubscription} path="/addsubscription" permit={"admin"} />
              <ProtectedRoute exact component={EditSubscription} path="/editsubscription" permit={"admin"} />
              <ProtectedRoute exact component={SubscriptionReport} path="/subscriptionreport" permit={"admin"} />
              <ProtectedRoute exact component={WithdrawsReports} path="/withdrawsReports" permit={"admin"} />
              <ProtectedRoute exact component={WithdrawList} path="/withdrawList" permit={"admin"} />
              <ProtectedRoute exact component={CorporateEarning} path="/corporateearning" permit={"corporateAdmin"} />
              <ProtectedRoute exact component={CorporateHistory} path="/corporatehistory" permit={"admin"}/>
              <ProtectedRoute exact component={FleetEarning} path="/fleetEarning" permit={"admin,fleetadmin"}/>
              <ProtectedRoute exact component={AdminReport} path="/adminReport" permit={"admin"}/>
              <Route path="/about-us" component={AboutUs} />
              <Route path="/terms-and-conditions" component={TermsAndCondition} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route path="/register" component={RegisterPage} />
              <Route path="/login" component={LoginPage} />
              <Route path="/" component={LandingPage} />
            </Switch>
          </Router>
        </AuthLoading>
      </FirebaseProvider>
    </Provider>
  );
}

export default App;